import { render, staticRenderFns } from "./VendorEdit.vue?vue&type=template&id=36e502d5&scoped=true"
import script from "./VendorEdit.vue?vue&type=script&lang=js"
export * from "./VendorEdit.vue?vue&type=script&lang=js"
import style0 from "./VendorEdit.vue?vue&type=style&index=0&id=36e502d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e502d5",
  null
  
)

export default component.exports